import { Lift } from "@models/lift.model";
import { Tray } from "@models/tray.model";
import { Slot } from "@models/slot.model";
import { Batch } from "@models/batch.model";
import {ToolPositionStatus} from "@models/enums/tool-position-status.enum";

export class ToolPosition {
    public lift: Lift;
    public tray: Tray;
    public slot: Slot;
    public batch: Batch;
    public status: ToolPositionStatus;
    public selected: boolean;

    constructor(toolPosition: any = {}) {
        this.lift = new Lift(toolPosition.lift || {});
        this.tray = new Tray(toolPosition.tray || {});
        this.slot = new Slot(toolPosition.slot || {});
        this.batch = new Batch(toolPosition.batch || {});
        this.status = toolPosition.status;
        this.selected = toolPosition.selected;
    }
}
